import { onUnmounted } from 'vue'
import { useSocket } from './useSocket'
import { useTabStore } from '@/stores/tabs'

/**
 * Listens to real-time events and marks inactive tabs as updated.
 * Initialize once in MainLayout — not per-component.
 */
export function useTabNotifications() {
  const { on, off } = useSocket()
  const tabStore = useTabStore()

  // Ticket events — mark /tickets tabs and specific ticket detail tabs
  function onTicketEvent(_data: { type?: string; ticketId?: number }) {
    tabStore.markTabUpdated('/tickets')
  }

  // Calendar events
  function onCalendarEvent() {
    tabStore.markTabUpdated('/calendar')
  }

  // SLA events — affects ticket tabs
  function onSlaEvent() {
    tabStore.markTabUpdated('/tickets')
  }

  // Chat events
  function onChatEvent() {
    tabStore.markTabUpdated('/chat')
  }

  // Todo events
  function onTodoEvent() {
    tabStore.markTabUpdated('/todos')
    tabStore.markTabUpdated('/my-work')
  }

  // Datto/device events
  function onDattoEvent() {
    tabStore.markTabUpdated('/assets')
    tabStore.markTabUpdated('/security')
  }

  // Register listeners
  on('ticket:event', onTicketEvent)
  on('sla:event', onSlaEvent)
  on('calendar:event', onCalendarEvent)
  on('chat:event', onChatEvent)
  on('todo:changed', onTodoEvent)
  on('datto:alert', onDattoEvent)
  on('datto:device', onDattoEvent)

  onUnmounted(() => {
    off('ticket:event', onTicketEvent)
    off('sla:event', onSlaEvent)
    off('calendar:event', onCalendarEvent)
    off('chat:event', onChatEvent)
    off('todo:changed', onTodoEvent)
    off('datto:alert', onDattoEvent)
    off('datto:device', onDattoEvent)
  })
}
